// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__25Qek","row":"styles_row__VJOAY","footer":"styles_footer__fPjDD","tableLight":"styles_tableLight__2gPqi"};